/* Totaria cart drawer "Add one more" upsell. Uses one delegated click listener, so it keeps working
   after Horizon re-renders the drawer (the drawer HTML is replaced on every cart change). */
if (!window.__ttCartUpsell) {
  window.__ttCartUpsell = true;

  const add = async (box, btn) => {
    if (btn.getAttribute('aria-busy') === 'true') return;
    const err = box.querySelector('[data-err]');
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const variant = String(box.dataset.variant);
    const fd = new FormData();
    fd.append('id', variant);
    fd.append('quantity', '1');
    if (box.dataset.plan) fd.append('selling_plan', box.dataset.plan);
    const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    if (ids.length) fd.append('sections', [...new Set(ids)].join(','));

    let events = null;
    try { events = await import('@shopify/events'); } catch (_) { events = null; }
    let deferred = null;
    if (events) {
      deferred = events.CartLinesUpdateEvent.createPromise();
      box.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'add', context: 'product', lines: [box.dataset.plan ? { merchandiseId: variant, quantity: 1, sellingPlanId: box.dataset.plan } : { merchandiseId: variant, quantity: 1 }], promise: deferred.promise,
      }));
    }
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST', body: fd, credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || '');
      if (!events) { window.location.reload(); return; }
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'tt-cart-upsell', itemCount: 1, sections: data.sections, didError: false },
      });
    } catch (error) {
      if (deferred) deferred.reject(error);
      if (err) {
        err.textContent = box.dataset.error || error.message || '';
        err.hidden = !err.textContent;
      }
      btn.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('tt-cart-upsell [data-add]');
    if (!btn) return;
    event.preventDefault();
    add(btn.closest('tt-cart-upsell'), btn);
  });
}
